import { useEffect, useState } from 'react';
import { Text } from '@chakra-ui/react';

import { CustomHeading, Link } from 'shared-components';

import QuestionPage from '../../../templates/question';
import Checkbox from '../../../molecules/checkboxQuestion';
import { Q } from '../../../../store/student/types';
import { saveConsents } from '../../../../store/student/actions';
import { Pages } from '../../../../store/student/consents/types';
import { useDispatch } from 'react-redux';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

export interface IDispatchProps {
  onNext: (config: any) => void;
  onBackToTaskList: () => void;
}

export interface IProps {
  sectionTitle: string;
  currentStep: number;
  steps: number;
  consent?: boolean;
  config: any;
}

type Props = IProps & IDispatchProps;

function ConsentsQPage4(props: Props) {
  const [consent, setConsent] = useState(props.consent || false);

  const dispatch = useDispatch();
  const onNext = (config: any) => dispatch(saveConsents(Pages.PAGE4, config));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  useEffect(() => {
    setConsent(props.consent || false);
  }, [props.consent, setConsent]);

  return (
    <QuestionPage
      complete={consent}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      <CustomHeading level={'h2'}>
        {props.config.Page4.heading ? props.config.Page4.heading : props.config.Page4.title}
      </CustomHeading>

      <Text
        fontSize={'lg'}
        dangerouslySetInnerHTML={{
          __html: props.config.Page4.blurb,
        }}
        sx={{
          'p, ol, ul': {
            mb: 4,
          },
          li: {
            ml: 12,
          },
          a: {
            color: 'link-color',
            textDecoration: 'underline',
            _hover: {
              color: 'link-hover-color',
            },
          },
        }}
      />

      {props?.config?.Page4?.externalLinkInstruction ? (
        <Text
          fontSize={'lg'}
          data-selector="instruction"
          dangerouslySetInnerHTML={{
            __html: props.config.Page4.externalLinkInstruction,
          }}
        />
      ) : null}

      {props?.config?.Page4?.externalLink ? (
        <Text fontSize={'lg'}>
          <Link href={props.config.Page4.externalLink} isExternal>
            {props?.config?.Page4?.externalLinkText ?? 'View Terms and Condition'}{' '}
          </Link>
        </Text>
      ) : null}

      {props?.config?.Page4?.externalLinkList?.length
        ? props?.config?.Page4?.externalLinkList.map(({ link, linkText }: { link: string; linkText: string }) => (
            <Text fontSize={'lg'}>
              <Link href={link} isExternal>
                {linkText}
              </Link>
            </Text>
          ))
        : null}

      <Checkbox
        blurb={props?.config?.Page4?.additionalBlurb ?? ''}
        key={Q.CONSENTS_4}
        id={Q.CONSENTS_4}
        isTicked={consent}
        checkboxLabel={props?.config?.Page4?.confirmCheckboxText ?? 'I Agree'}
        onChange={(_key: string, isTicked: boolean) => setConsent(isTicked)}
      />
    </QuestionPage>
  );
}

export default ConsentsQPage4;
